import { CompanyTitledPage } from "../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import useInputObject from "../../hooks/useInputObject";
import { insertBuyer } from "../../http/api/BuyerAPI";
import BuyerInfo from "./BuyerInfo";
import validateBuyer from "./validBuyer";

const infoTableCellSx = {
  fontSize: 18,
};

// 新規買人更新ページ
const BuyerInsertPage = () => {
  const navigate = useNavigate();
  const buyerInfo = useInputObject({});

  const handleClickReturn = (event) => {
    navigate(-1);
  };

  // 登録ボタンをクリックするイベント
  async function handleClickInsert() {
    try {
      let insertItem = buyerInfo.Value;
      insertItem.createdId = 1; //TODO JWTを追加した後削除
      insertItem.updatedId = 1; //TODO JWTを追加した後削除
      console.log("Insert Buyer data : ", insertItem);
      if (!checkValidBuyer(insertItem)) return;
      let response = await insertBuyer(insertItem);
      alert("買人を登録しました。");
      navigate("/company/buyer");
    } catch {
      alert("買人を登録できませんでした。");
    }
  }

  function checkValidBuyer(buyerInfo) {
    const errs = validateBuyer(buyerInfo);
    if (errs.length > 0) {
      console.log(errs);
      alert(errs.join("\n"));
      return false;
    }
    return true;
  }

  return (
    <CompanyTitledPage title="買人登録">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              買人情報の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={handleClickInsert}
              id="buyer-form-submit-button"
            >
              登録
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={handleClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      {/* 買人情報 */}
      <BuyerInfo buyerInfo={buyerInfo} isUpdateMode={false} />
    </CompanyTitledPage>
  );
};
export default BuyerInsertPage;
